import React from 'react';
import {Box, Button, ButtonGroup, IconButton, Menu, MenuItem} from '@mui/material';
import {useFileContext} from '../context/FileContext';
import SortIcon from '@mui/icons-material/Sort';
import {SORT_OPTIONS} from 'context/useSorting';

// Sort button with direction toggle
export const SortButton = () => {
   const {
      sort: {
         handleSortMenuClose,
         handleSortMenuOpen,
         anchorEl,
         sortOption,
         toggleSortDirection,
         sortDirection,
      },
   } = useFileContext();

   return (
      <Box sx={{display: 'flex', alignItems: 'center'}}>
         <ButtonGroup variant="contained">
            <Button
               variant="outlined"
               onClick={toggleSortDirection}
               aria-label="Toggle sort direction"
               style={{borderColor: 'inherit'}}
            >
               {sortDirection === 'asc' ? (
                  <SortIcon />
               ) : (
                  <SortIcon sx={{transform: 'rotate(180deg) scaleX(-1)'}} />
               )}
            </Button>
            <Button
               variant="outlined"
               // startIcon={<SortIcon />}
               onClick={handleSortMenuOpen}
               // sx={{textTransform: 'none'}}
            >
               Sort by: {SORT_OPTIONS.find((opt) => opt.key === sortOption)?.label}
            </Button>
         </ButtonGroup>
         <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleSortMenuClose()}>
            {SORT_OPTIONS.map((option) => (
               <MenuItem
                  key={option.key}
                  selected={option.key === sortOption}
                  onClick={() => handleSortMenuClose(option.key)}
               >
                  {option.label}
               </MenuItem>
            ))}
         </Menu>
      </Box>
   );
};
